






import { defineComponent, computed } from "@vue/composition-api";
import ImageModel from "@/ts/models/imageClass";

export default defineComponent({
  name: "TinyAvatar",

  props: {
    image: {
      type: Object as () => ImageModel
    },
    size: {
      type: String,
      default: "35"
    }
  },

  setup(props) {
    var imageSrc: any = computed(() => {
      if (props.image) {
        return props.image.thumb;
      } else {
        var image = new ImageModel();
        return image.thumb;
      }
    });

    return {
      imageSrc
    };
  }
});
